export var syncStorageKey = function (noteId) { return "".concat(noteId, "-updatedAt"); };
export var outOfSyncErrorMessage = 'Out of sync';
